import { ADDITION, MULTIPLICATION } from './gameParts';
import BonusScreen from './scenes/BonusScreen';
import GameScreen from './scenes/GameScreen';
import InstructionsScreen from './scenes/InstructionsScreen';
import IntroScreen from './scenes/IntroScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [IntroScreen, InstructionsScreen, GameScreen, BonusScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: IntroScreen.KEY,

  gameType: MULTIPLICATION, // can be addition or multiplication

  CURRENT_LEVEL: 1,
  BONUS_TIME: 0,
  LEVEL_SCORE: 0,
  STARS_COLLECTED: 0,

  ROUND1_BEST: 0,
  ROUND2_BEST: 0,
  ROUND3_BEST: 0,

  ALL_LEVELS_COMPLETED: false,
};